var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FB9A02",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,38.971 L36,37.482 C36,35.329 34.846,33.341 32.977,32.273 L27.006,28.848",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.995,28.847 L11.024,32.272 C9.154,33.341 8,35.329 8,37.482 L8,38.971",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,31 C17.582,31 14,26.418 14,22 L14,18 C14,13.582 17.582,10 22,10 C26.418,10 30,13.582 30,18 L30,22 C30,26.418 26.418,31 22,31 Z",
    id: "Stroke-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,22.0000002 C44,29.8598433 39.806824,37.1226374 33,41.0525595 C26.193176,44.9824805 17.806824,44.9824805 11,41.0525595 C4.193176,37.1226374 0,29.8598433 0,22.0000002 C0,14.1401572 4.193176,6.87736308 11,2.94744103 C17.806824,-0.982480011 26.193176,-0.982480011 33,2.94744103 C39.806824,6.87736308 44,14.1401572 44,22.0000002 Z",
    id: "Stroke-7",
    strokeLinecap: "square"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cd54b8fe357cce14be3b2b121e85d7f4.svg";
export { ForwardRef as ReactComponent };